import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import { FaHome, FaFileAlt, FaSignOutAlt, FaLayerGroup, FaList, FaUser,} from 'react-icons/fa';
import imagen2 from '../img/get_view2.png';

const Sidebar = () => {
  const navigate = useNavigate();
  const handleInicioClick = () => navigate('/menuAdmin');
  const handleUsuariosClick = () => navigate("/VerUsuarios");
  const handleAsistentesClick = () => navigate('/Asistentes');
  const handleLideresClick = () => navigate('/Lideres');
  const handleSeniorsClick = () => navigate('/Seniors');
  
  const handleExitClick = () => {
    navigate('/'); // Redirige al usuario a la página de inicio de sesión o la ruta principal
    localStorage.clear(); // Elimina todos los elementos de localStorage
    window.location.reload(); // Refresca la página
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <img src={imagen2} alt="GET View Logo" className="sidebar-logo" />
      </div>
      <div className="sidebar-section">
        <p>Aplicaciones</p>
        <div className="profile-link" onClick={handleInicioClick}>
          <FaHome /> Inicio
        </div>
        <div className="profile-link" onClick={handleUsuariosClick}>
          <FaLayerGroup /> Usuarios GET View
        </div>
        <div className="profile-link multiline-text" onClick={handleAsistentesClick}>
          <FaList /> Asistentes GET
        </div>
        <div className="profile-link multiline-text" onClick={handleLideresClick}>
          <FaFileAlt /> Líderes y subrogantes
        </div>
        <div className="profile-link" onClick={handleSeniorsClick}>
          <FaUser /> Seniors GET
        </div>
        <div className="sidebar-section bottom-items">
        <p>Otros</p>
        <div className="profile-link" onClick={handleExitClick}>
          <FaSignOutAlt /> Cerrar Sesión
          </div>
      </div>
    </div>
  </div>
  );
};

export default Sidebar;
